import React, { useState, useEffect } from 'react';
import BodyGroupSingle from './BodyGroupSingle';
import { PrefState } from '../../../../store/reducers/prefReducer';
import { RootState } from '../../../../store/index';
import { useDispatch, useSelector } from 'react-redux';

interface Props {
    rows: any[]
    groupType: any
    group: string
    grouperList: any[]
    dynamicTableService: any
    selectedRadioRows: any[]
    handleMouseMove: Function
    tooltipObject: any
    status: any
    densitySelected: string
    columns: any[]
    fontSize: any
    handleLinkClick: Function
    functionsRow: any[] | undefined
    rowClick: any
    handleRowClick: Function
    functionRadio: any
    getStatusRow: Function
    expandCloseAll: { expand: boolean, close: boolean }
}

const BodyGroup: React.FC<Props> = (props) => {
    const [expandAll, setExpandAll] = useState<boolean>(false);
    const [closeAll, setCloseAll] = useState<boolean>(false);
    const dispatch = useDispatch();
    const pref = useSelector<RootState, PrefState>(state => state.pref);

    const countLength = (rows: any) => {
        let length = 0;

        if (rows[0] instanceof Array) {
            rows.map((row: any) => {
                if (row instanceof Array) length += countLength(row);
            });
        }
        else {
            length = rows.length
        }

        return length;
    }

    useEffect(() => {
        if (closeAll === true) setCloseAll(false);
    }, [closeAll]);

    useEffect(() => {
        if (expandAll === true) setExpandAll(false);
    }, [expandAll]);

    useEffect(() => {
        if (props.expandCloseAll.expand == true) {
            setExpandAll(true);
            handleVisibleAll(true);
        }
        else if (props.expandCloseAll.close == true) {
            setCloseAll(true);
            handleVisibleAll(false);
        }
    }, [props.expandCloseAll])

    const getStatusRow = (status: string) => {
        const statusMap: { [key: string]: string } = {
            'primary': '#141b4d',
            'secondary': '#1b3a7a',
            'danger': '#e64646',
            'success': '#a5bf3e',
            'warning': '#ffb800',
            'link': '#0580ce'
        };
    
        return statusMap[status] || status;
    };

    const handleVisible = (type: string, value: boolean) => {
        let groupVisible = pref.data?.groupVisible ?? {};
        groupVisible = { ...groupVisible, [type]: value };

        dispatch({ type: "PREF_UPDATE", payload: { name: "groupVisible", value: groupVisible } });
    }

    const handleVisibleAll = (value: boolean) => {
        let groupVisible = pref.data?.groupVisible ?? {};
        
        Object.keys(groupVisible).map((field) => {
            let field_ = field as string;

            if (groupVisible[field_] === !value) {
                groupVisible[field_] = value;
            }
        });

        dispatch({ type: "PREF_UPDATE", payload: { name: "groupVisible", value: groupVisible } });
    }

    const clearExpandCloseAll = () => {
        dispatch({ type: "PREF_UPDATE", payload: { name: "expandCloseAll", value: undefined } });
    }
    
    return (
        <BodyGroupSingle
            rows={props.rows}
            groupType={props.groupType}
            group={props.group}
            grouperList={props.grouperList}
            dynamicTableService={props.dynamicTableService}
            countLength={countLength}
            expandAll={expandAll}
            closeAll={closeAll}
            selectedRadioRows={props.selectedRadioRows}
            handleMouseMove={props.handleMouseMove}
            tooltipObject={props.tooltipObject}
            status={props.status}
            densitySelected={props.densitySelected}
            columns={props.columns}
            fontSize={props.fontSize}
            handleLinkClick={props.handleLinkClick}
            functionsRow={props.functionsRow}
            rowClick={props.rowClick}
            handleRowClick={props.handleRowClick}
            functionRadio={props.functionRadio}
            getStatusRow={getStatusRow}
            handleVisible={handleVisible}
            expandCloseAll={props.expandCloseAll}
            clearExpandCloseAll={clearExpandCloseAll}
        />
    );
};

export default BodyGroup;